// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-wizard-header[data-v-329d8008]{align-content:center;height:50px}.test-img[data-v-329d8008]{border:1px solid #b3b3b3;margin:5px 5px 0}.v-input--selection-controls[data-v-329d8008]{margin-top:4px!important;padding-top:4px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
